import { IEntity } from './entity';
import { IVenture } from './venture';

export interface IDocument {
  id: number;
  name: string;
  frequency: string;
  criticality: enCriticality;
  doubt: string;
  hidden: boolean;
  ventureId?: number;
  venturesId?: string[];
  entityId?: number;
  tabId?: number;
  subTabId?: number;
  titleHyperLink?: string;
  hyperLink?: string;
  createdDate: Date;
  updatedDate: Date;

  entityName?: string;
  tabName?: string;
  subTabName?: string;

  entity?: IEntity;
  tab?: IEntity;
  subTab?: IEntity;
  venture?: IVenture;
}

export enum enCriticality {
  'Alta' = 'Alta',
  'Média' = 'Média',
  'Baixa' = 'Baixa'
}

export enum enFrequency {
  'Semanal' = 'Semanal',
  'Quinzenal' = 'Quinzenal',
  'Mensal' = 'Mensal',
  'Bimestral' = 'Bimestral',
  'Trimestral' = 'Trimestral',
  'Quadrimestral' = 'Quadrimestral',
  'Semestral' = 'Semestral',
  'Anual' = 'Anual',
  'Bienal' = 'Bienal',
  'Trienal' = 'Trienal',
  'Quadrienal' = 'Quadrienal',
  'Quinquenal' = 'Quinquenal'
}

export const NA = 'N/A';